import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="footer py-4">
      <Container>
        <Row>
          <Col md={6} className="text-start">
            <h5 className="footer-brand">
              <img src="/mintHubLogo.png" alt="MintHub - Professional websites for local businesses" className="brand-logo me-2" />
              <span className="brand-mint">Mint</span><span className="brand-hub">Hub</span>
            </h5>
            <p className="text-muted">Professional websites for local businesses</p>
            <a
              href="https://www.facebook.com/people/MintHub/61583651261029/"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-social-link"
              aria-label="MintHub on Facebook"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16" className="me-1">
                <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H8.75V16c3.824-.604 6.75-3.934 6.75-7.951"/>
              </svg>
              Facebook
            </a>
          </Col>
          <Col md={6} className="text-end">
            <p className="text-muted mb-0">&copy; 2026 MintHub. All rights reserved.</p>
            <p className="text-muted mb-0 footer-legal-links">
              <Link to="/privacy">Privacy Policy</Link>
              <span className="footer-legal-separator">|</span>
              <Link to="/terms">Terms of Service</Link>
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}

export default Footer;
